import { isSlotElement } from '@vedalib/editor'
import { ButtonActionType, ButtonBlockAction } from '@vedalib/editor/lib/elements'
import lodash from 'lodash'

import Node from 'components/Editor/cource/layout/Node'
import { SHELL_SIZE_KEYS } from 'components/Editor/types/data.constants'
import { PreviewMode } from 'services/Store/Project/enums'

import ContinueButtonElement from './Buttons/ContinueButtonElement'
import CourseButtonElement from './Buttons/CourseButtonElement'
import DecisionButtonElement from './Buttons/DecisionButtonElement'
import DefaultButtonElement from './Buttons/DefaultButtonElement'
import DownloadFileElement from './Buttons/DownloadFileElement'
import EndButtonElement from './Buttons/EndButtonElement'
import EndCourseButtonElement from './Buttons/EndCourseButtonElement'
import LinkButtonElement from './Buttons/LinkButtonElement'
import NavigationButtonElement from './Buttons/NavigationButtonElement'
import ResetButtonElement from './Buttons/ResetButtonElement'
import RestartButtonElement from './Buttons/RestartButtonElement'
import StartButtonElement from './Buttons/StartButtonElement'
import SubmitButtonElement from './Buttons/SubmitButtonElement'
import type { ButtonElementType } from './buttonTypes'

const COMPONENT_BY_ACTION_TYPE = {
  default: DefaultButtonElement,
  [ButtonActionType.link]: LinkButtonElement,
  [ButtonActionType.navigation]: NavigationButtonElement,
  [ButtonActionType.file]: DownloadFileElement,
  [ButtonActionType.continue]: ContinueButtonElement,
  [ButtonActionType.decision]: DecisionButtonElement,
  [ButtonBlockAction.testRestart]: RestartButtonElement,
  [ButtonBlockAction.testEnd]: EndButtonElement,
  [ButtonBlockAction.courseStart]: CourseButtonElement,
  [ButtonBlockAction.testStart]: StartButtonElement,
  [ButtonBlockAction.validate]: SubmitButtonElement,
  [ButtonBlockAction.courseEnd]: EndCourseButtonElement,
  [ButtonBlockAction.reset]: ResetButtonElement,
}

const ButtonElement: ButtonElementType = ({ element, styles, block, mode, ...rest }) => {
  const { action, actionType, actionData } = element.value
  const id = isSlotElement(element) ? element.value?.item?.value : null

  const Component =
    COMPONENT_BY_ACTION_TYPE[action as keyof typeof COMPONENT_BY_ACTION_TYPE] ||
    COMPONENT_BY_ACTION_TYPE[actionType as keyof typeof COMPONENT_BY_ACTION_TYPE] ||
    DefaultButtonElement

  const stylesWithSize = {
    ...styles,
    root: {
      ...styles.root,
      ...lodash.pick(styles.shell, SHELL_SIZE_KEYS),
    },
  }

  return (
    mode.previewMode !== PreviewMode.feedback && (
      <Component
        {...rest}
        block={block}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        element={{ ...element, element: { value: actionData } } as any}
        mode={mode}
        styles={stylesWithSize}
      >
        {id ? <Node block={block!} id={id} mode={mode} isSlot /> : null}
      </Component>
    )
  )
}
export default ButtonElement
